import { ePartySubType, ePartyType, Party } from "reg-hub-common";

export class Constants {
    public static apiRoot = "https://bapi.reghub.dev/api/v1";
    public static clientRoot = "https://admin.reghub.dev";
    public static idpAuthority = "https://auth.reghub.dev";
    public static clientId = "web.client";

    // url parameters
    public static corporationID = "corporationID";
    public static userGroupID = "userGroupID";
    public static userID = "userID";

    public static statusComplete = "Complete"

    public static ordersHubNegotiateUrl: string = "/Hubs/Orders/Negotiate";
    public static orderMessagesHubNegotiateUrl: string = "/Hubs/OrderMessages/Negotiate";
}